<!-- about-page.vue -->
<template>
  <Layout>
    <br>
    <h1 class="text-3xl text-left pl-4">About SGLM</h1>
    <br>
    <div class="text-left pl-4">
    <p>Shree Ghoghari Lohana Mahajan Trust, Mumbai came into being by the kind donations of primary Lohana settlers from various regions in Gujarat.</p>
    <br>
    
    <p>Established in 1842, registered as Public Trust (Registration No. A-1586-B). Its office is located at Lohana Bhuvan, Paliram Road, Andheri (West), Mumbai – 400 058 (Contact Number: +91 22 26283715)</p>
    <br>
    <p>The trust has come a long way since then and is a meeting ground for almost 1,800 families in Mumbai . </p>
    <br>
    <p>The primary objective of the Trust is to provide monetary aid for the deserving members of the Ghoghari lohana community with respect to:</p>
      <li>Hospitalizations and Medicine</li>
      <li>School and college and Higher Education Aid</li>
      <li>Monetary aid to the financially weak families</li>
      <li>Food Security (subsidized grains)</li>
      <li>Community Awareness Programs</li>
      <li>Community Welfare Services</li>
      <li>Subsidies for Religious Travels and pilgrimages</li>
      <li>Support for Senior Citizen community</li>
      <br>
      <p>The beneficiaries of our services and support are solely the families Ghoghari Lohana community from the Mumbai region, who over time have benefited immensely from various support and aid programs of the Trust.</p>
      </div>
  </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'

export default {
  components: {
    Layout
  }
}
</script>
  